import Switch from '@/components/Switch/Switch';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import { ContactSalesTooltipContent } from './ContactSalesTooltipContent';

const TransparentSwitchWrapper = styled.div`
    position: relative;
`;

const styles = {
    tooltip: {
        sx: {
            backgroundColor: '#FFF',
            color: theme.colors.secondary[900],
            boxShadow:
                '5.3px 13.3px 18.8px -1.2px rgba(187, 187, 187, 0.29), 2.4px 6.1px 8.6px -0.8px rgba(187, 187, 187, 0.23), 1.1px 2.8px 3.9px -0.4px rgba(187, 187, 187, 0.17), 0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.12)',
            padding: '16px',
            borderRadius: '4px',
        },
    },
};

export const BrandingToolTip = () => {
    return (
        <Tooltip title={<ContactSalesTooltipContent />} placement="top" slotProps={styles}>
            <TransparentSwitchWrapper>
                <Switch checked={false} />
            </TransparentSwitchWrapper>
        </Tooltip>
    );
};
